import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FA = ({...rest}) => {
  return <FontAwesomeIcon {...rest} color="white" />
}

export default FA;
